import { render, staticRenderFns } from "./UpgradeApplicationDialog.vue?vue&type=template&id=6c0a3b2c&scoped=true"
import script from "./UpgradeApplicationDialog.vue?vue&type=script&lang=js"
export * from "./UpgradeApplicationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a3b2c",
  null
  
)

export default component.exports